import api from 'api'
import { IWebinar } from 'interfaces/webinars'
import { appendMockWebinarsUiDev } from './appendMockWebinarsUiDev'

const getWebinars = async () => {
  const response = await api.get('/administration/sidebar_shortcuts/meetings')
  const items = response.data.data.map(
    (item: { attributes: IWebinar }) => item.attributes
  )
  return appendMockWebinarsUiDev(items)
}

export default getWebinars
